import clsx from "clsx";
import * as React from "react";
import styles from "./input.module.scss";

export interface InputProps extends React.ComponentProps<"input"> {
  inputSize?: "sm" | "default" | "lg";
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, inputSize = "default", ...props }, ref) => {
    return (
      <input
        type={type}
        className={clsx(
          styles.input,
          inputSize === "sm" && styles.sm,
          inputSize === "lg" && styles.lg,
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
